import { Model, prop } from 'datx';
import { jsonapi } from 'datx-jsonapi';

export class Resource extends jsonapi(Model) {
  @prop.identifier
  public id!: string;
}
